import 'babel-polyfill';
import $ from 'jquery'; // note that window.$ = window.JQuery = $;
import '../../node_modules/bootstrap/js/src/tab';
import 'url-search-params-polyfill';
const MobileDetect = require('mobile-detect');

/* -----------------------------------------------------------
 * JavaScript modules which are needed before other includes
 * or modules should be loaded here.
 * ----------------------------------------------------------- */

require('./common/api');
require('./common/general');
require('./common/platform');

/* -----------------------------------------------------------
 * JavaScript includes which are needed before other includes
 * or modules should be loaded here.
 * ----------------------------------------------------------- */

require('./modules/primary-menu');
require('./modules/bookmarks');
require('./modules/overview-templates');
require('./modules/owl-carousel');

const wpForm = require('./modules/wp-form').default; // This isn't really global, but it uses markup that lives in DB
const gaTracking = require('./modules/ga-tracking').default;

$(document).ready(() => {

  wpForm.init();
  gaTracking.init();
  window.mobileDetect = new MobileDetect(window.navigator.userAgent);

  offsetAnchor();
  function offsetAnchor() {
    if(location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 100);
    }
    $('[data-gs-type="none"]').on('click', function(e) {
      e.preventDefault();
    })
  }
  
  if (!$.trim( $('.sidebar-widget > .widgets').html()).length == 0) {
    $('.sidebar-widget:not(.hide-sidebar)').addClass('sidebar-has-content');
  }
  if ($('.sidebar-widget > .widgets').length) {
    $('.sidebar-widget').addClass('loaded');
  }

  if ($('.btn-open-popup-win').length) {
    MicroModal.init();
    $(document).on('click', '.btn-open-popup-win', function (event) {
      event.preventDefault();
      var modalName = $(this).attr('data-custom-open');
      MicroModal.show(modalName ,{
        onShow: function() {
          $('.template-landing-level-1.template-landing-level-1-b').addClass('modal-isopen');
        },
        onClose: function() {
          $('.template-landing-level-1.template-landing-level-1-b').removeClass('modal-isopen');
        }
      });
    });
    
  }

  const $accordionTitles = $('.accordion-main-container .accordion-bottom-container .accordion-block-module .accordion-content .accordion-title h4');
  if ($accordionTitles.length) {
    $accordionTitles.on('click', function (event) {
      event.preventDefault();
      let $accordionContent = $(this).closest('.accordion-content');
      let $accordionContentModule = $(this).closest('.accordion-bottom-container');
      let $bottomContentCheck = $accordionContentModule.find('.accordion-content');
      if (!$accordionContent.hasClass('is-open')) {
        $accordionContentModule.addClass('accord-isopen');
        $accordionContent.addClass('is-open');
      } else {
        $accordionContent.removeClass('is-open');
        if (!$($bottomContentCheck).hasClass('is-open')) {
          $accordionContentModule.removeClass('accord-isopen');
        }
      }
    });
  }

  // Manage sticky header on desktop
  const stickyHeaderDesktop = $('#sticky-header-desktop');
  const stickyHeaderDesktopCloseBtn = $('#sticky-header-desktop-close');
  const isStickyHeaderDesktopClosed = window.dfApi.getLocalStorage(window.dfCONSTANTS.localstorage.stickyHeaderDesktopClosed);
  if(isStickyHeaderDesktopClosed === null){
    stickyHeaderDesktop.slideDown(1000);
  }
  stickyHeaderDesktopCloseBtn.on('click', function(e){
    stickyHeaderDesktop.hide();
    window.dfApi.updateLocalStorage(window.dfCONSTANTS.localstorage.stickyHeaderDesktopClosed, 'true');
  });

  // Manage cookie consent notice
  const cookieConsentWrapper = $('#cookie-consent-wrapper');
  const cookieConsentCloseBtn = $('#cookie-consent-close-button');
  const isCookieConsentClosed = window.dfApi.getLocalStorage(window.dfCONSTANTS.localstorage.cookieConsentClosed);
  if(isCookieConsentClosed === null){
    cookieConsentWrapper.fadeIn(1000);
  }
  cookieConsentCloseBtn.on('click', function(e){
    cookieConsentWrapper.hide();
    window.dfApi.updateLocalStorage(window.dfCONSTANTS.localstorage.cookieConsentClosed, 'true');
  });

});

require('./modules/sms');


/**
 * This function is not used in the theme files but it may be used by Google Analytics
 */
function isOnScreen(elem) {
  // if the element doesn't exist, abort
  if (elem.length == 0)
  {
    return;
  }
  var $window = $(window)
  var viewport_top = $window.scrollTop()
  var viewport_height = $window.height()
  var viewport_bottom = viewport_top + viewport_height
  var $elem = $(elem)
  var top = $elem.offset().top
  var height = $elem.height()
  var bottom = top + height

  return (top >= viewport_top && top < viewport_bottom) ||
    (bottom > viewport_top && bottom <= viewport_bottom) ||
    (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}
